import { useQuery } from "react-query";
import { studyCenterService } from "@services/study-center";
import { studyCenterQueryKeys } from "./queryKeys";

export const useStudyCenterEducationalPromotionQuery = (
  id: number | undefined
) => {
  const { data: educationalPromotion, ...stuff } = useQuery(
    studyCenterQueryKeys.educationalPromotionById(id!),
    () => studyCenterService.getPromotionById(id!),
    {
      enabled: typeof id !== "undefined",
    }
  );

  return {
    educationalPromotion,
    ...stuff,
  };
};
